// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar-module--container--3NDRs"};